export interface Beer {
  name: string;
  abv: string;
  image: string;
  id: string;
  type: string;
  funFact?: string;
  description?: string;
  availability?: string;
  untappdLink?: string;
  order: number;
  /** When false, users cannot select this beer for a custom flight. Defaults to true. */
  available?: boolean;
}

export const sortBeersForSelection = (beers: Beer[]): Beer[] => {
  return [...beers].sort((a, b) => {
    const aAvailable = a.available !== false;
    const bAvailable = b.available !== false;
    if (aAvailable !== bAvailable) return aAvailable ? -1 : 1;
    return a.order - b.order;
  });
};

export interface BeerFlight {
  name?: string;
  description?: string;
  beers: (Beer | null)[];
  createdAt?: Date;
}

export interface SavedBeerFlight {
  id: string;
  beers: Beer[];
  createdAt: string;
}
